import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { catDiasSemana } from "../../Categorias y Estados/catDiasSemana";
import { catEnvioMensual } from "../../Categorias y Estados/catEnvioMensual";
import { catEnvioQuincenal } from "../../Categorias y Estados/catEnvioQuincenal";
import { catFrecuenciaAct } from "../../Categorias y Estados/catFrecuenciaAct";
import { catFrecuenciaTiempo } from "../../Categorias y Estados/catFrecuenciaTiempo";
import { Servicios } from "../../Servicios/Servicios";
import { ACTSeleccionarServicios } from "./ACTSeleccionarServicios";



const columns = () =>
(
    {
        c_cliente_id: new EntityColumn<string>({ name: 'c_cliente_id', type: 'char', length: 20, flags: c.PK, prompt: 'Cliente ID' }),
        c_servicio_id: new EntityColumn<string>({ name: 'c_servicio_id', type: 'char', length: 20, flags: c.PK, prompt: 'Servicio' }),
        dt_fecha_inicio: new EntityColumn<Date>({ name: 'dt_fecha_inicio', type: 'datetime', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Fecha de inicio' }),
        i_dias_envio_informacion: new EntityColumn<number>({ name: 'i_dias_envio_informacion', type: 'int', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Días antes de entrega información' }),
        i_dias_finalizacion: new EntityColumn<number>({ name: 'i_dias_finalizacion', type: 'int', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Días antes de finalización' }),
        vc_observaciones: new EntityColumn<string>({ name: 'vc_observaciones', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Observaciones' }),
        c_frecuenciatiempo_id: new EntityColumn<string>({ name: 'c_frecuenciatiempo_id', type: 'char', length: 20, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Frecuencia de Datos' }),
        c_diassemana_id: new EntityColumn<string>({ name: 'c_diassemana_id', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Día' }),
        c_enviomensual_id: new EntityColumn<string>({ name: 'c_enviomensual_id', type: 'char', length: 20, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Semana' }),
        c_envioquincenal_id: new EntityColumn<string>({ name: 'c_envioquincenal_id', type: 'char', length: 20, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Semana' }),
        c_frecuenciaact_id: new EntityColumn<string>({ name: 'c_frecuenciaact_id', type: 'char', length: 20, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Frecuencia de Retención' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        clse_brwStandard: { name: 'clse_brwStandard', keyMappings: { c_servicio_id: 0 } }
    }
)

const lookups = () =>
(
    {
        'Servicios': {
            name: 'Servicios',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Servicios(client, parentKeys)
        },

        'FrecuenciaTiempo': {
            name: 'FrecuenciaTiempo',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catFrecuenciaTiempo(client, parentKeys)
        },

        'DiasSemana': {
            name: 'DiasSemana',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catDiasSemana(client, parentKeys)
        },

        'EnvioMensual': {
            name: 'EnvioMensual',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catEnvioMensual(client, parentKeys)
        },

        'EnvioQuincenal': {
            name: 'EnvioQuincenal',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catEnvioQuincenal(client, parentKeys)
        },
     
        'FrecuenciaActualizacion': {
            name: 'FrecuenciaActualizacion',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catFrecuenciaAct(client, parentKeys)
        },
    }
)

const clientActions = () =>
(
    {
        ACTSeleccionarServicios: ACTSeleccionarServicios,
    }
)
export class ClientesServiciosDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();
    clientActions = clientActions();

    constructor() {
        super('ClientesServicios');
    }
}